import React, { ReactText, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import Props from "./newProps";
import TextareaAutogrow from "../../ui/TextareaAutogrow";
import getProfessionNewFieldSelector from "../../../../state/selectors/ProfessionSelectors/getProfessionNewFieldSelector";
import setNewProfessionFieldAction from "../../../../state/actions/ProfessionActions/setNewProfessionFieldAction";
import styled from "styled-components";

const NewProfessionCell: React.FC<Props> = ({ label, field }) => {
    const dispatch = useDispatch();
    const selectedField = useSelector((state: Store) => getProfessionNewFieldSelector(state, field));
    const setNewProfessionField = useCallback((data) => dispatch(setNewProfessionFieldAction(data, field)), [dispatch, field]);
    return (
        <FlexWrapper>
            <Left>{label}</Left>
            <Right>
                <TextareaAutogrow editedValue={selectedField as ReactText} onChange={(value: string) => setNewProfessionField(value)} />
            </Right>
        </FlexWrapper>
    );
};

export default NewProfessionCell;

const FlexWrapper = styled.div`
    display: flex;
    padding-bottom: 2rem;
`;

const Left = styled.div`
    width: 23%;
    font-weight: 700;
    font-size: 1.1rem;
`;

const Right = styled.div`
    width: calc(100% - 23%);
    font-size: 1.1rem;
    word-break: break-word;
    p {
        margin-bottom: 0.5rem;
    }
    textarea {
        font-weight: 100;
        padding: 0.5rem;
    }
`;
